// extracted by mini-css-extract-plugin
module.exports = {"root":"newPlaylist_root__3EWkF","container":"newPlaylist_container__2UbzP","tracks":"newPlaylist_tracks__cGTje","notice":"newPlaylist_notice__3j1xO"};